import styled from 'styled-components';

export const StackWrapper = styled.div`
  margin-right: 27px;
`;
